import { I18n, Language, LanguageOptions, LanguageOption } from '../types';

let I18n: I18n = window.I18n;

const setTranslations = (value: I18n) => {
  I18n = value;
};

setTranslations(I18n);

const getTranslator = (keysScope?: string) => {
  return (scope: string, options?: Object) => {
    return I18n.translate(`js.modules.react.${keysScope ? `${keysScope}.` : ''}${scope}`, options);
  };
};

const setLanguage = ({ language }: Language): void => {
  window.Cookie.set('user_locale', language);
  window.location.reload();
};

const languageOptions: LanguageOptions = {
  BE: [
    {
      name: 'french',
      flag: 'FR',
      locale: 'fr_BE',
    },
    {
      name: 'dutch',
      flag: 'NL',
      locale: 'nl_BE',
    },
  ],
  CA: [
    {
      name: 'french',
      flag: 'FR',
      locale: 'fr_CA',
    },
    {
      name: 'english',
      flag: 'GB',
      locale: 'en_CA',
    },
  ],
};

const getAvailableLanguages = (): LanguageOption[] =>
  languageOptions[I18n.country as keyof LanguageOptions] || [];

export { setTranslations, getTranslator, I18n, setLanguage, getAvailableLanguages };
